import { searchPrincipalPermissions } from '../../../services/coam';
import { RESOURCE_TYPE as resourceType } from '../../../constants/common';

const readUpdateDelete = async ({ resourceId, principal }) => {
  const { permissions = [] } = await searchPrincipalPermissions({ principal, resourceType, resourceId });
  return permissions;
};

export default readUpdateDelete;
